import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import collectionReducer from './collectionSlice';
import appReducer from './appSlice';
import shopifyReducer from './shopifySlice';
import billingReducer from './billingSlice';
import imageReducer from './imageSlice';
import galleryReducer from './gallerySlice';
import modelReducer from './modelSlice.ts';


export const store = configureStore({
    reducer: {
        auth: authReducer,
        collections: collectionReducer,
        app: appReducer,
        shopify: shopifyReducer,
        billing: billingReducer,
        gallery: galleryReducer,
        images: imageReducer,
        models: modelReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
